import React from "react"
import { SiteHeader } from "../redesign/components/site/SiteHeader"
import { SiteFooter } from "../redesign/components/site/SiteFooter"
import { SiteLocation } from "../redesign/SiteLocation"
import { getLanguageFromPath } from "../contexts/TranslationContext"
import "../redesign/styles.css"
import "../redesign/client-updates.css"

export default function Layout({ children, location = { pathname: "/fr" } }) {
  const pathname = location.pathname
  const language = getLanguageFromPath(pathname)
  if (/^\/(?:login|register|check-certificate)(?:\/|$)/.test(pathname))
    return <>{children}</>
  return (
    <SiteLocation.Provider value={pathname}>
      <div className="hcc-site">
        <a href="#main-content" className="hcc-skip">
          {language === "fr" ? "Aller au contenu" : "Skip to content"}
        </a>
        <SiteHeader />
        <main id="main-content">{children}</main>
        <SiteFooter lang={language} />
      </div>
    </SiteLocation.Provider>
  )
}
